import type { ElementTweenFunction } from '../types';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { gsap } from 'gsap';

export const pulse: ElementTweenFunction = ({ target, options, scrollTrigger, direction }) => {
    if (direction === "back") return { tween: undefined, position: "0" }

    const duration = options?.duration ?? 0.5; // Default duration 0.5s
    const scale = options?.scale ?? 1.05; // Default scale 1.05
    const ease = options?.ease ?? 'power1.inOut'; // Default ease

    const tween = gsap.timeline({ repeat: 2, yoyo: true }); // Repeat indefinitely and reverse smoothly

    tween.to(target, {
        duration: duration / 2, // Half duration for scale up
        ease: ease,
        scale
    });

    // The yoyo: true handles the return to scale: 1

    if (scrollTrigger?.trigger) {
        // Note: ScrollTrigger might not be typical for a continuous pulse,
        // but we include it for consistency with the ElementTweenFunction type.
        // It could be used to start/stop the pulse based on scroll position.
        ScrollTrigger.create({
            animation: tween,
            ...scrollTrigger,
        });
    }

    // For a continuous animation like pulse, the insertion point might be less critical,
    // but we return "<" as a default.
    return { tween, position: "<" };
};
